import { render } from "./DashboardHeader.vue?vue&type=template&id=4d76cdc7"
import script from "./DashboardHeader.vue?vue&type=script&lang=js"
export * from "./DashboardHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__